import { fetchJSON } from "../util/fetch-utils";
export class VelavuAPIDeviceModels {
    /**
     * Get all device models
     * @returns Promise<DeviceModel[]> List of all device models
     */
    getAllDeviceModels() {
        return fetchJSON("/devicemodels");
    }
}
export default VelavuAPIDeviceModels;
//# sourceMappingURL=velavu-api-device-models.js.map